import React, { useEffect, useState }  from "react";
import { connect } from "react-redux";
import { useParams } from 'react-router-dom';
import Card from "components/card";
import {
  getLaunchTrainingModule, doTrainingModuleDelete
} from '../../../redux/trainingmodule/trainingModuleState';
import { Scorm12API } from "scorm-again";
import { API_URL } from "../../../constants";
import { AuthHeader } from '../../../services/authheader';

const ViewTrainingModule = ({recorData, getRecord }) => {
	const { moduleId } = useParams();
	const [apiReady, setApiReady] = useState(false);
	
	useEffect(() => {
        getRecord(moduleId);
	}, [getRecord, moduleId]);

	useEffect(() => {

		if (!recorData?.url) return;

		const api = new Scorm12API({
			autocommit: true,
			logLevel: 2,
			cmi: recorData?.cmi || {},
			mastery_override: false,

			lmsCommitUrl: API_URL + "/api/v1/scorm/commit", 
			
			requestHandler: async (commitUrl, commitData) => {
				const token = localStorage.getItem("token");

				return fetch(commitUrl, {
					method: "POST",
					headers: AuthHeader({Accept: "application/json"}),
					body: JSON.stringify({
						training_module_id : moduleId,
						cmi: commitData,
					}),
				});
			},

		});

		window.API = api;
		window.IsLmsPresent = true;

		try {
			window.top.API = api;
			window.top.IsLmsPresent = true;
			window.parent.API = api;
			window.parent.IsLmsPresent = true;
		} catch (e) {
			console.warn("SCORM API parent/top attach failed", e);
		}

		setApiReady(true);

		return () => {
			delete window.API;
			delete window.IsLmsPresent;
		};
	}, [recorData, moduleId]);

	if (!apiReady || !recorData?.url) return null;

	return (
	    <div className="mt-3">
	    	<div className="mt-5 grid h-full grid-cols-1 gap-4">
	      		<Card extra={"w-full h-full p-4"}>
					 {apiReady && recorData?.url && (
						<>
							{/* <div>{recorData?.url}</div> */}
							<iframe
								key={recorData.url}
								src={recorData.url}
								title="SCORM Player"
								className="w-full h-screen border-0"
								style={{
									width: "100%",
									height: "100vh",
									border: "none",
								}}
								allowFullScreen
							/>
						</>
					)}
				</Card>
	      </div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
	recorData: state.trainingModule.launchModule?.data,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (data) => dispatch(getLaunchTrainingModule(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewTrainingModule);